import React from "react";
import { AnchorMenu } from "../../components/anchor-menu";
import { Recap } from "./sections/recap";
import { Ideation } from "./sections/ideation";
import { Consolidation } from "./sections/consolidation";
import { Refinement } from "./sections/refinement";
import { Adoption } from "./sections/adoption";
import { ReadMore } from "../../components/read-more";
import { Conclusion } from "./sections/conclusion";

export enum DesignAnchor {
  RECAP = "recap",
  IDEATION = "ideation",
  CONSOLIDATION = "consolidation",
  REFINEMENT = "refinement",
  ADOPTION = "adoption",
  CONCLUSION = "conclusion",
}

export interface IDesignProps {
  currAnchor: string;
  showAnchorMenu: boolean;
  handleMenuClick: (anchor: string) => void;
  handleNavClick: (anchor: string) => void;
  onComponentMounted: (anchorList: string[]) => void;
}

export class Design extends React.Component<IDesignProps> {
  public static readonly ANCHOR_LIST: string[] = [
    DesignAnchor.RECAP,
    DesignAnchor.IDEATION,
    DesignAnchor.CONSOLIDATION,
    DesignAnchor.REFINEMENT,
    DesignAnchor.ADOPTION,
    DesignAnchor.CONCLUSION,
  ];

  componentDidMount() {
    this.props.onComponentMounted(Design.ANCHOR_LIST.slice());
  }

  render() {
    return (
      <React.Fragment>
        {this.props.showAnchorMenu ? (
          <AnchorMenu
            selectedAnchor={this.props.currAnchor || DesignAnchor.RECAP}
            handleMenuClick={this.props.handleMenuClick}
            anchorList={Design.ANCHOR_LIST.slice()}
          />
        ) : undefined}
        <main>
          <article>
            <Recap
              sectionId={DesignAnchor.RECAP}
              index={Design.ANCHOR_LIST.indexOf(DesignAnchor.RECAP)}
            />
            <Ideation
              sectionId={DesignAnchor.IDEATION}
              index={Design.ANCHOR_LIST.indexOf(DesignAnchor.IDEATION)}
            />
            <Consolidation
              sectionId={DesignAnchor.CONSOLIDATION}
              index={Design.ANCHOR_LIST.indexOf(DesignAnchor.CONSOLIDATION)}
              handleNavClick={this.props.handleNavClick}
            />
            <Refinement
              sectionId={DesignAnchor.REFINEMENT}
              index={Design.ANCHOR_LIST.indexOf(DesignAnchor.REFINEMENT)}
            />

            <Adoption
              sectionId={DesignAnchor.ADOPTION}
              index={Design.ANCHOR_LIST.indexOf(DesignAnchor.ADOPTION)}
            />

            <Conclusion
              sectionId={DesignAnchor.CONCLUSION}
              index={Design.ANCHOR_LIST.indexOf(DesignAnchor.CONCLUSION)}
            />

            <ReadMore
              onNav={this.props.handleNavClick}
              links={[
                {
                  url: "/guidelines",
                  cta: "Download Implementation Resources",
                  internal: true,
                },
                {
                  url: "/research",
                  cta: "Learn About the Research Process",
                  internal: true,
                },
              ]}
            />
          </article>
        </main>
      </React.Fragment>
    );
  }
}
